<template>
    <hts-drawer
        v-model="visible"
        color="main"
        size="xl"
        :title="$t('labels.viewRoute')"
        @close="close">
        <div
            :style="{ minWidth: minWidthScroll }"
            class="flex w-full h-full gap-3">
            <div class="flex w-full h-full gap-3">
                <div class="w-1/2">
                    <ul
                        v-if="formData.positions?.length"
                        class="timeline timeline-snap-icon max-md:timeline-compact timeline-vertical mt-[40px]">
                        <li
                            v-for="(position, index) in formData.positions"
                            :key="index">
                            <div class="timeline-middle">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 24 24"
                                    class="h-5 w-5">
                                    <path
                                        fill-rule="evenodd"
                                        d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>

                            <div class="w-full timeline-end">
                                <div class="translate-y-[-40px]">
                                    <div class="flex justify-center items-center gap-2">
                                        <hts-admincp-select-location
                                            ref="selectLocation"
                                            v-model="position.locationId"
                                            v-model:text="position.locationName"
                                            class="w-full"
                                            name="location"
                                            prop="location"
                                            key-id="_id"
                                            key-label="locationName"
                                            :label="$t('labels.location')"
                                            readonly />
                                    </div>

                                    <div
                                        v-if="getRoutingPosition(position._id, formData.positions?.[index + 1]?._id)?.distance"
                                        v-loading="mapLoading.route"
                                        class="p-4 bg-white rounded-lg shadow-sm border border-gray-100 mt-5">
                                        <!-- Distance Section -->
                                        <p class="font-medium text-gray-700 flex items-center gap-2 mt-3 px-2 py-2 bg-gray-50 rounded-md">
                                            <span class="text-primary-600">
                                                <svg
                                                    class="w-5 h-5"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l5.447-2.724A1 1 0 0021 13.382V2.618a1 1 0 00-1.447-.894L15 4m0 13V4m0 0L9 7" />
                                                </svg>
                                            </span>
                                            Quãng đường:
                                            <span class="text-primary-600">
                                                {{ $formatters.mToKm(getRoutingPosition(position._id, formData.positions?.[index + 1]?._id)?.distance) }} km
                                            </span>
                                        </p>

                                        <p class="font-medium text-gray-700 flex items-center gap-2 mt-1 px-2 py-2 bg-gray-50 rounded-md">
                                            <span class="text-primary-600">
                                                <svg
                                                    class="w-5 h-5"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </span>
                                            Thời gian:
                                            <span class="text-primary-600">
                                                {{
                                                    $formatters.convertMinutesToNaturalLanguage(
                                                        getRoutingPosition(position._id, formData.positions?.[index + 1]?._id)?.duration,
                                                        'second'
                                                    )
                                                }}
                                            </span>
                                        </p>

                                        <div class="flex items-center justify-between mt-3 px-2 py-2 bg-gray-50 rounded-md">
                                            <!-- Toll Stations Label -->
                                            <p class="font-medium text-gray-700 flex items-center gap-2">
                                                <span class="text-yellow-600">
                                                    <svg
                                                        class="w-5 h-5"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                            stroke-width="2"
                                                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                </span>
                                                Trạm thu phí:
                                            </p>
                                        </div>
                                        <ul class="list-disc ml-6 text-gray-600">
                                            <li
                                                v-for="toll in getRoutingPosition(position._id, formData.positions?.[index + 1]?._id)?.tollStations"
                                                :key="toll"
                                                class="text-start text-primary-600">
                                                {{ toll.locationName }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <hr v-if="index < formData.positions.length - 1" >
                        </li>
                    </ul>
                    <div class="mt-5">
                        <hts-select-category-vehicle
                            v-model="formData.vehicleCategoryIds"
                            prop="workflowData"
                            multiple
                            readonly
                            :data-multiple="formData.vehicleCategories" />

                        <hts-form-input
                            v-model="formData.tolerance"
                            :label="$t('labels.tolerance')"
                            readonly
                            type="number">
                            <template #suffix>
                                Km
                            </template>
                        </hts-form-input>

                        <hts-form-input
                            v-model="formData.totalDistance"
                            :label="$t('labels.totalKm')"
                            type="number"
                            readonly>
                            <template #suffix>
                                Km
                            </template>
                        </hts-form-input>
                        <hts-form-input
                            v-model="formData.totalDuration"
                            :label="$t('labels.totalDuration')"
                            type="number"
                            readonly>
                            <template #suffix>
                                {{ $t('labels.hour') }}
                            </template>
                        </hts-form-input>

                        <hts-form-textarea
                            v-model="formData.description"
                            readonly
                            :label="$t('labels.description')" />
                    </div>
                </div>
                <div class="w-1/2">
                    <div class="w-full h-full">
                        <hts-map-route
                            ref="map"
                            center-marker
                            :route="markers"
                            :route-separated="routes"
                            :draggable="draggable"
                            :show-location="showLocation"
                            :lat-lng-location-routes="CLatLngLocationRoutes">
                            <template #top>
                                <div class="flex min-h-5 justify-end gap-3">
                                    <hts-map-icon-location store-key="route" />
                                </div>
                            </template>
                        </hts-map-route>
                    </div>
                </div>
            </div>
        </div>
    </hts-drawer>
</template>
<script setup lang="ts">
import routeMap from './route-map'

import screen from '~/components/utils/screen'

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm}px`
})

const { map: mapStore } = $store()

const { $formatters } = useNuxtApp()
const visible = ref(false)
const id = ref('')
const loading = ref(false)

const {
  markers,
  setMarkers,
  routes,
  setRoutes,
  mapLoading,
  getRoutingPosition,
  routingPositions,
  showLocation,
  draggable,
  CLatLngLocationRoutes,
  setRoutingPositions
} = routeMap('route')

const formData = ref<{
  positions: { [key: string]: any }[]
  vehicleCategoryIds: string[]
  vehicleCategories: { [key: string]: any }[]
  description: string
  tolerance: number | null
  totalDistance: number
  totalDuration: number
}>({
  positions: [
    {
      locationId: '',
      locationName: '',
      lat: '',
      lng: '',
      _id: $formatters.generateId()
    },
    {
      locationId: '',
      locationName: '',
      lat: '',
      lng: '',
      _id: $formatters.generateId()
    }
  ],
  vehicleCategoryIds: [],
  vehicleCategories: [],
  description: '',
  tolerance: 0,
  totalDistance: 0,
  totalDuration: 0
})

const totalKm = computed(() => {
  return (routingPositions.value?.route?.distance || 0) + (formData.value.tolerance || 0)
})

const open = async (idValue: string) => {
  mapStore.setShowLocation({ route: false })

  mapLoading.value.route = true
  loading.value = true
  id.value = idValue
  visible.value = true
  draggable.value = false
  await getData(idValue)
  loading.value = false
  mapLoading.value.route = false
}

const getData = async (id: string) => {
  const api = $url.route.route.get
  const data: any = await $api(api, { uriParams: { ID: id } })
  const resData: any = data.data.value

  if (resData?.success) {
    formData.value = resData.data

    setRoutingPositions(resData.data.routingPositions)
    nextTick(() => {
      handlePositionsChanged()
    })
  }
}

const close = () => {
  visible.value = false
}

const handlePositionsChanged = () => {
  setMarkers(formData.value.positions, {
    renderMarkerByIndexNumber: true
  })
  setRoutes(formData.value.positions, {
    renderMarkerByIndexNumber: true
  })
}

defineExpose({ open, close })
</script>

<style scoped>
.timeline-vertical:where(.timeline-snap-icon) > li {
  --timeline-col-start: minmax(0, 0fr);
}
</style>
